package com.nonopn.skywatcher.common.app.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.nonopn.skywatcher.design.init.InitializeScreen

@Composable
fun EnsureAppModel(
    content: @Composable (appModel: AppModel) -> Unit
) {
    val appModel = LocalApp.current
    val state by appModel.states.collectAsState()

    LaunchedEffect(state) {
        if (!state.initialized) {
            appModel.initialize()
        }
    }

    if (!appModel.isInitialized()) {
        InitializeScreen(globalApp = appModel)
    } else {
        content(appModel)
    }
}
